// Brand name used in page text. The logo image is src/assets/logo.jpg.
export const BRAND = 'Elegance';
export const CURRENCY = 'Rs';
export const MAIN_CATEGORIES = [
  { key: 'clothing', label: 'Clothing' },
  { key: 'handbags', label: 'Handbags' },
];
export const slug = (s) =>
  String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
export const money = (n) => `${CURRENCY} ${Number(n || 0).toLocaleString('en-PK')}`;
const ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
export const sizeRank = (s) => {
  const i = ORDER.indexOf(String(s).toUpperCase());
  return i === -1 ? 99 : i;
};
